require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-dropping-out-of-college-was-the-best-decision-i-ever-made.json") })
        }
      }, "path---blog-why-dropping-out-of-college-was-the-best-decision-i-ever-made");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-dropping-out-of-college-was-the-best-decision-i-ever-made!./.cache/json/blog-why-dropping-out-of-college-was-the-best-decision-i-ever-made.json
// module id = 1145
// module chunks = 231608221292675